import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import classnames from 'classnames'
import style from './style.css'
import MLCDLIcons from '@macmillan-learning/ml-react-cdl-icons'

class RestrictableButton extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <button
        id={this.props.id}
        onClick={this.props.restricted ? null : this.props.clickEventHandler}
        style={this.props.hidden ? { display: 'none' } : null}
        className={classnames(
          'btn-cdl-secondary',
          style.btnCdlSecondary,
          (this.props.restricted ? style.editButtonDisabled : style.editButton),
          { disabled: this.props.restricted },
          (this.props.textButton ? style.textLike : ''),
          (this.props.whiteText ? style.whiteText : ''),
          (this.props.className ? this.props.className : '')
        )}
        tabIndex={this.props.tabIndex}
        data-test-id={this.props.dataTestId}
        readOnly={true}
        aria-label={`${this.props.restricted ? 'Restricted disabled action ' : ''}${this.props.ariaLabel}`}
      >
        {
          (this.props.textButton && this.props.restricted)
            ? ''
            : this.props.buttonText
        }
        {this.props.restricted
          ? <OverlayTrigger
            placement={'bottom'}
            overlay={<Tooltip id={'tooltip-restricted'}>Restricted</Tooltip>}
            delayShow={300}
            delayHide={150}
          >
            <span
              className={classnames(
                'editButtonLockIcon',
                style.editButtonLockIcon,
                (this.props.textButton ? style.textLikeRestricted : '')
              )} tabIndex={this.props.tabIndex}
            >
              {this.props.textButton
                ? <MLCDLIcons
                  width={'20'}
                  height={'20'}
                  className={classnames('lock', style.circle_lock_outlineIcon)}
                  type={'lock'}
                />
                : <MLCDLIcons
                  className={classnames('circle_lock_outlineIcon', style.circle_lock_outlineIcon)}
                  type={'circle_lock_outline'}
                />
              }
            </span>
          </OverlayTrigger>
          : null
        }
      </button>
    )
  }
}

RestrictableButton.propTypes = {
  className: PropTypes.string,
  clickEventHandler: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  dataTestId: PropTypes.string,
  restricted: PropTypes.bool,
  buttonText: PropTypes.string,
  ariaLabel: PropTypes.string,
  textButton: PropTypes.bool,
  whiteText: PropTypes.bool
}

export default RestrictableButton
